import { render } from "./AdminNavigationDropdown.vue?vue&type=template&id=965962a0"
import script from "./AdminNavigationDropdown.vue?vue&type=script&lang=js"
export * from "./AdminNavigationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__